module.exports = __webpack_public_path__ + "img/product_97.f25f272.webp";